import { Nilable } from "@shared/utils";

export interface IComboMovilDTO {
    email: string;
    testing: boolean;
    combo_id: number;
}

export class ComboMovilDTO {
    public email = "";
    public testing = true;
    public combo_id = 0;

    constructor(json: Nilable<Partial<IComboMovilDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IComboMovilDTO>) {
        if (json.email != null) {
            this.email = json.email;
        }
        if (json.testing != null) {
            this.testing = json.testing;
        }
        if (json.combo_id != null) {
            this.combo_id = json.combo_id;
        }
    }

    public toJSON(): IComboMovilDTO {
        return {
            email: this.email,
            testing: this.testing,
            combo_id: this.combo_id
        };
    }
}
